import { ANALYTICS_MAX_SELECTED_GROUP_PROFILES } from 'app/modules/analytics/config/analyticsConfig';
import { getSortedAnalyticsPerformancePagesFromGroupPages } from 'app/modules/analytics/utils/profileGroupPageToPageData';
import type { ProfileGroupPage } from 'types/Page';

// A disconnected profile stays in the list so it can be reconnected, but it has
// no data to query, so it must never start enabled.
export function isSelectableGroupPage(page: ProfileGroupPage): boolean {
  return !!page.isConnected;
}

export function getInitialEnabledGroupPageIds(
  pages: ProfileGroupPage[] | undefined,
): ReadonlySet<number> {
  return new Set(
    getSortedAnalyticsPerformancePagesFromGroupPages(pages)
      .filter(isSelectableGroupPage)
      .slice(0, ANALYTICS_MAX_SELECTED_GROUP_PROFILES)
      .map((page) => page.id),
  );
}

export function toggleEnabledGroupPageId(
  enabledPageIds: ReadonlySet<number>,
  pageId: number,
): ReadonlySet<number> {
  if (enabledPageIds.has(pageId)) {
    if (enabledPageIds.size === 1) {
      return enabledPageIds;
    }

    const next = new Set(enabledPageIds);
    next.delete(pageId);
    return next;
  }

  if (enabledPageIds.size >= ANALYTICS_MAX_SELECTED_GROUP_PROFILES) {
    return enabledPageIds;
  }

  const next = new Set(enabledPageIds);
  next.add(pageId);
  return next;
}
